import { Store } from 'src/store/index';

const getOriginalQuantity = (store: Store) => store.design.originalQuantity;
export default getOriginalQuantity;
